document.addEventListener('DOMContentLoaded', () => {
    initMobileMenu();
    initForm();
    initWizardChat();
    initShowSubTab();
    initKnowledgeFilter();
    initAccordions();
    document.querySelectorAll('.js-slider')
        .forEach(initSlider);
});

// Accordions Functional

function initAccordions() {
  const headers = document.querySelectorAll('.kb-header');

  headers.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.kb-item');
      const body = item.querySelector('.kb-body');
      const icon = item.querySelector('.kb-chevron');

      document.querySelectorAll('.kb-item').forEach(el => {
        if (el !== item) {
          el.querySelector('.kb-body')?.classList.remove('open');
          el.querySelector('.kb-chevron')?.classList.remove('open');
        }
      });

      body?.classList.toggle('open');
      icon?.classList.toggle('open');
    });
  });
}

// About Tabs Functional

function initShowSubTab() {
  const buttons = document.querySelectorAll('.tab-btn[data-tab]');
  const contents = document.querySelectorAll('.sub-content');

  function showSubTab(id, btn) {
    contents.forEach(el => el.classList.remove('active'));
    buttons.forEach(el => el.classList.remove('active'));

    const target = document.getElementById(id);
    if (target) target.classList.add('active');
    if (btn) btn.classList.add('active');
  }

  buttons.forEach(btn => {
    btn.addEventListener('click', function () {
      const id = this.dataset.tab;
      showSubTab(id, this);
    });
  });
}

// Knowledge base direction filter

function initKnowledgeFilter() {
  const section = document.getElementById('page-knowledge');
  if (!section) return;

  const buttons = section.querySelectorAll('.kb-tabs .tab-btn[data-direction]');
  const items = section.querySelectorAll('.kb-item');

  if (!buttons.length || !items.length) return;

  function filterByDirection(slug) {
    items.forEach(item => {
      const directions = (item.dataset.directions || '').split(/\s+/).filter(Boolean);
      const match = slug === 'all' || directions.includes(slug);

      item.hidden = !match;

      if (!match) {
        item.querySelector('.kb-body')?.classList.remove('open');
        item.querySelector('.kb-chevron')?.classList.remove('open');
      }
    });
  }

  buttons.forEach(btn => {
    btn.addEventListener('click', function () {
      buttons.forEach(el => {
        el.classList.remove('active');
        el.setAttribute('aria-selected', 'false');
      });

      this.classList.add('active');
      this.setAttribute('aria-selected', 'true');

      filterByDirection(this.dataset.direction);
    });
  });
}

// Wizard Functional

let selectedUnit = '';
let selectedLawyer = '';
let selectedKeyLawyer = '';
let selectedUserType = '';
let selectedMilitaryForce = '';

function initWizardChat() {
    let selectedUnitFiles = {};
    let selectedTopicMode = 'consult';

    if (!document.getElementById('wizard-step-num')) return;

    const wizardSteps = {
        1: 'З ким ми зараз спілкуємось?',
        2: 'Оберіть ваше військове формування:',
        3: 'Оберіть вашу військову частину:',
        4: 'Оберіть тему звернення:'
    };

    function setWizardStep(stepNum, title) {
        document.querySelectorAll('[id^="step-"]').forEach(s => s.style.display = 'none');

        document.getElementById('step-' + stepNum).style.display = 'block';

        document.getElementById('wizard-step-num').textContent =
            String(stepNum).replace(/[abc]/g, '');

        document.getElementById('wizard-step-title').textContent = title;
    }

    function wizardBack(toStep) {
        setWizardStep(toStep, wizardSteps[toStep] || '');
    }

    function nextStep(stepNum) {
        if (stepNum === 2) {
            setWizardStep(2, wizardSteps[2]);
        }

        if (stepNum === 3) {
            setWizardStep(3, wizardSteps[3]);
        }

        if (stepNum === 4) {
            setWizardStep(4, wizardSteps[4]);
        }
    }

    function selectMilitaryForce(btn) {
      const forceID = btn.dataset.forceId;
      selectedMilitaryForce = btn.dataset.forceName || '';

      document.querySelectorAll('.unit-btn').forEach(unitBtn => {
        const forceIDs = (unitBtn.dataset.forceIds || '').split(',');
        unitBtn.style.display = forceIDs.includes(forceID) ? '' : 'none';
      });

      nextStep(3);
    }

    function selectUnit(btn) {
      const unitName = btn.dataset.unit;
      const lawyerID = btn.dataset.lawyer;
      const keylawyerID = btn.dataset.keylawyer;
      selectedUnit = unitName;
      selectedLawyer = lawyerID;
      selectedKeyLawyer = keylawyerID;

      selectedUnitFiles = {
          checklist: btn.dataset.checklist,
          memo: btn.dataset.memo,
          report: btn.dataset.report
      };

      const lawyerInput = document.querySelector('[data-consult-form] input[name="lawyer"]');
      const keylawyerInput = document.querySelector('[data-consult-form] input[name="keylawyer"]');
      if (lawyerInput) {
          lawyerInput.value = lawyerID || '';
      }

        if (keylawyerInput) {
            keylawyerInput.value = keylawyerID || '';
        }

      setWizardStep(4, wizardSteps[4]);
    }

    function fillLibraryFiles() {
      const items = document.querySelectorAll('#step-5b > div > div');

      if (items.length < 3) return;

      const files = [
        selectedUnitFiles.checklist,
        selectedUnitFiles.memo,
        selectedUnitFiles.report
      ];

      items.forEach((item, index) => {
        const link = item.querySelector('a');

        const file = files[index];

        if (file) {
          link.href = file;
          link.classList.remove('btn-disabled');
          link.textContent = 'Завантажити';
          link.setAttribute('download', '');
        } else {
          link.removeAttribute('href');
          link.classList.add('btn-disabled');
          link.textContent = 'Немає файлу';
        }
      });
    }

    function selectTopic(type) {
      if (type === 'consult') {
          const text = document.getElementById('consult-text');

          if (text) {
              if (selectedTopicMode === 'review') {
                  text.textContent =
                      'Залиште ваш контакт та відгук щодо роботи проєкту';
              } else {
                  text.textContent =
                      "Залиште ваш контакт та коротко суть питання — адвокат зв'яжеться з вами:";
              }
          }

          setWizardStep('5a', 'Контакт');
      }

      if (type === 'library') {
        fillLibraryFiles();
        setWizardStep('5b', 'Матеріали');
      }

      if (type === 'knowledge') {
        setWizardStep('5c', 'Інформація');
      }
    }

    document.querySelectorAll('.choice-btn').forEach(btn => {
      btn.addEventListener('click', () => {
          selectedUserType = btn.dataset.type;
          nextStep(2);
      });
    });

    document.querySelectorAll('.unit-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            selectUnit(btn);
        });
    });

    document.querySelectorAll('.military-force-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            selectMilitaryForce(btn);
        });
    });

    document.querySelectorAll('.topic-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            selectedTopicMode = btn.dataset.mode || 'consult';
            selectTopic(btn.dataset.type);
        });
    });

    document.querySelectorAll('.btn-ghost').forEach(btn => {
        btn.addEventListener('click', () => {
            wizardBack(Number(btn.dataset.backStep) || 1);
        });
    });
}

// Mobile Menu Function

function initMobileMenu() {
  const toggleBtn = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  if (!toggleBtn || !mobileMenu) return;

  const openIcon = toggleBtn.querySelector('.menu-open');
  const closeIcon = toggleBtn.querySelector('.menu-close');

  toggleBtn.addEventListener('click', () => {
    const isOpen = mobileMenu.classList.toggle('open');

    toggleBtn.classList.toggle('active', isOpen);

    if (openIcon) openIcon.style.display = isOpen ? 'none' : 'block';
    if (closeIcon) closeIcon.style.display = isOpen ? 'block' : 'none';
  });

  mobileMenu.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => {
      mobileMenu.classList.remove('open');
      toggleBtn.classList.remove('active');

      if (openIcon) openIcon.style.display = 'block';
      if (closeIcon) closeIcon.style.display = 'none';
    });
  });

  document.addEventListener('click', (e) => {
    if (
      mobileMenu.classList.contains('open') &&
      !mobileMenu.contains(e.target) &&
      !toggleBtn.contains(e.target)
    ) {
      mobileMenu.classList.remove('open');
      toggleBtn.classList.remove('active');

      if (openIcon) openIcon.style.display = 'block';
      if (closeIcon) closeIcon.style.display = 'none';
    }
  });
}

// Slider Functional

function initSlider(slider) {

    const track = slider.querySelector('.js-slider-track');
    const btnPrev = slider.querySelector('.js-slider-prev');
    const btnNext = slider.querySelector('.js-slider-next');

    if (!track || !btnPrev || !btnNext) return;

    const desktopCardWidth =
        parseInt(slider.dataset.cardWidth || 216, 10);
    const mobileCardWidth =
        parseInt(slider.dataset.mobileCardWidth || desktopCardWidth, 10);
    const autoplayEnabled = slider.dataset.autoplay !== 'false';
    const autoplayInterval = parseInt(
        slider.dataset.autoplayInterval || 4000,
        10
    );
    const preferReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
    ).matches;

    let current = 0;
    let direction = 1;
    let autoplayTimer = null;

    function getCardWidth() {
        return window.matchMedia('(max-width: 640px)').matches
            ? mobileCardWidth
            : desktopCardWidth;
    }

    function getVisible() {
        return Math.max(
            1,
            Math.floor(track.parentElement.offsetWidth / getCardWidth())
        );
    }

    function total() {
        return track.children.length;
    }

    function maxIndex() {
        return Math.max(0, total() - getVisible());
    }

    function clamp(v) {
        return Math.min(Math.max(0, v), maxIndex());
    }

    function update() {

        current = clamp(current);

        track.style.transform =
            `translateX(-${current * getCardWidth()}px)`;

        btnPrev.disabled = current === 0;

        btnNext.disabled = current >= maxIndex();
    }

    function stopAutoplay() {
        if (autoplayTimer) {
            clearInterval(autoplayTimer);
            autoplayTimer = null;
        }
    }

    function startAutoplay() {
        stopAutoplay();

        if (!autoplayEnabled || preferReducedMotion) return;
        if (total() <= getVisible()) return;
        if (document.hidden) return;

        autoplayTimer = setInterval(() => {
            const max = maxIndex();

            // Reverse once the last slide is in view (end),
            // or once we reach the start again.
            if (current >= max) direction = -1;
            else if (current <= 0) direction = 1;

            current += direction;
            update();
        }, autoplayInterval);
    }

    function go(delta) {
        direction = delta > 0 ? 1 : -1;
        current += delta;
        update();
        startAutoplay();
    }

    btnPrev.addEventListener('click', () => go(-1));
    btnNext.addEventListener('click', () => go(1));

    let startX = 0;

    track.addEventListener('touchstart', e => {
        startX = e.touches[0].clientX;
        stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchend', e => {

        const diff =
            e.changedTouches[0].clientX - startX;

        if (Math.abs(diff) > 40) {
            go(diff < 0 ? 1 : -1);
        } else {
            startAutoplay();
        }

    }, { passive: true });

    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
    });

    window.addEventListener('resize', () => {
        update();
        startAutoplay();
    });

    update();
    startAutoplay();
}

// Form Functional

function initForm() {
  document.querySelectorAll('[data-consult-form]').forEach(form => {

    const nameInput  = form.querySelector('[name="name"]');
    const phoneInput = form.querySelector('[name="phone"]');
    const commentInput = form.querySelector('[name="comment"]');
    const descriptionInput = form.querySelector('[name="description"]');
    let lawyerInput = form.querySelector('[name="lawyer"]');
    let keylawyerInput = form.querySelector('[name="keylawyer"]');

    if (!nameInput || !phoneInput) return;

    phoneInput.value = '+380 ';

    function formatPhone(value) {
      let digits = value.replace(/\D/g, '');

      if (digits.startsWith('380')) digits = digits.slice(3);
      digits = digits.substring(0, 9);

      let result = '+380 ';

      if (digits.length > 0) {
        result += '(' + digits.substring(0, 2);
      }

      if (digits.length >= 2) {
        result += ') ' + digits.substring(2, 5);
      }

      if (digits.length >= 5) {
        result += '-' + digits.substring(5, 9);
      }

      return result;
    }

    phoneInput.addEventListener('input', function () {
      this.value = formatPhone(this.value);
    });

    phoneInput.addEventListener('keydown', function (e) {
      const isDelete = e.key === 'Backspace' || e.key === 'Delete';
      if (!isDelete) return;

      const digits = this.value.replace(/\D/g, '');

      if (this.selectionStart === 0 && this.selectionEnd === this.value.length) {
        e.preventDefault();
        this.value = '+380 ';
        return;
      }

      if (this.selectionStart <= 4) {
        e.preventDefault();
        return;
      }

      e.preventDefault();

      let clean = digits.startsWith('380')
        ? digits.slice(3)
        : digits;

      clean = clean.slice(0, -1);

      this.value = formatPhone('+380' + clean);
    });

    const submitButton = form.querySelector('button[type="submit"]');
    const defaultSubmitText = submitButton ? submitButton.innerHTML : '';
    let isSubmitting = false;

    const isValidName = v =>
      /^[a-zA-Zа-яА-ЯіІїЇєЄґҐ\s'-]{2,}$/.test(v.trim());

    const isValidPhone = v =>
      /^380\d{9}$/.test(v.replace(/\D/g, ''));

    nameInput.addEventListener('input', function () {
      if (isValidName(this.value)) {
        this.classList.remove('input-error');
      }
    });

    form.addEventListener('submit', async e => {
      e.preventDefault();

      if (isSubmitting) return;

      let valid = true;

      [nameInput, phoneInput].forEach(el =>
        el.classList.remove('input-error')
      );

      if (!isValidName(nameInput.value)) {
        nameInput.classList.add('input-error');
        valid = false;
      }

      if (!isValidPhone(phoneInput.value)) {
        phoneInput.classList.add('input-error');
        valid = false;
      }

      if (!valid) return;

      isSubmitting = true;

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
        submitButton.textContent = 'Надсилання...';
      }

      try {
        const token = await grecaptcha.execute(
          myAjax.recaptcha_site_key,
          { action: 'consult_form' }
        );

        let description = '';

        if (typeof selectedUserType !== 'undefined' && selectedUserType) {
          description += 'Тип заявника: ' + selectedUserType;
        }

        if (typeof selectedMilitaryForce !== 'undefined' && selectedMilitaryForce) {
          description += '<br>Військове формування: ' + selectedMilitaryForce;
        }

        if (typeof selectedUnit !== 'undefined' && selectedUnit) {
          description += '<br>Військова частина та підрозділ: ' + selectedUnit;
        }

        if (typeof selectedLawyer !== 'undefined' && selectedLawyer) {
            lawyerInput.value = selectedLawyer;
        }

        if (typeof selectedKeyLawyer !== 'undefined' && selectedKeyLawyer) {
            keylawyerInput.value = selectedKeyLawyer;
        }

        if (commentInput && commentInput.value.trim()) {
          description += '<br>Коментар: ' + commentInput.value.trim();
        }

        if (descriptionInput) {
          descriptionInput.value = description;
        }

        const formData = new URLSearchParams({
          action: 'send_to_crm',
          client_name: nameInput.value,
          client_phone: phoneInput.value.replace(/\D/g, ''),
          client_description: descriptionInput.value,
          resp_lawyer: lawyerInput.value,
          key_resp_lawyer: keylawyerInput.value,
          recaptcha_token: token
        });

        const response = await fetch(myAjax.ajaxurl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
          body: formData
        });

        const result = await response.json();

        if (result.success) {
          const wrapper = form.closest('#step-5a');

          if (wrapper) {
            wrapper.innerHTML = `
              <div class="success-box">
                ✅ Заявка прийнята
              </div>
            `;
          }

        } else {
          alert('Помилка відправки');
        }

      } catch (err) {
        console.error(err);
        alert('Помилка зʼєднання');
      } finally {
        isSubmitting = false;

        if (submitButton) {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
          submitButton.innerHTML = defaultSubmitText;
        }
      }
    });

  });
}
